import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import WhatIsSection from './components/WhatIsSection';
import WhySection from './components/WhySection';
import ComparisonTable from './components/ComparisonTable';
import HowItWorks from './components/HowItWorks';
import CategoryCards from './components/CategoryCards';
import SafetySection from './components/SafetySection';
import ArticlePreview from './components/ArticlePreview';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';
import { WEBSITE_SCHEMA, FAQ_SCHEMA } from '@/utils/schema-utils';

export default function Home() {
  return (
    <>
      <JsonLd data={[WEBSITE_SCHEMA, FAQ_SCHEMA]} />
      <Navbar />
      <main>
        <HeroSection />
        <WhatIsSection />
        <WhySection />
        <ComparisonTable />
        <HowItWorks />
        <CategoryCards />
        <SafetySection />
        <ArticlePreview />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}